import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { classAddedMobile, scrollMobileSelector } from '../../../../store/reducers/scrollMobileReducer';
import { secondContractAdded, secondContractSelector } from "../../../../store/reducers/secConReducer";
import { primaryContractSelector } from '../../../../store/reducers/primConReducer';
import { pathAdded } from '../../../../store/reducers/pathsReducer';
import { promoCodeSelector } from "../../../../store/reducers/promoCodeReducer";
import { useForm } from "react-hook-form";
import Tooltip from "../../../registered/tooltip/Tooltip";
import ErrorMessage from "./error/ErrorMessage";
import Select from "react-select";
import {emailValidationRegex, nameValidationRegex, emailValidationRegexAllowPersonal} from "../../../../constants";
import { isSkippedAdded } from '../../../../store/reducers/skipSecContReducer';
import { registrationSettingsSelector } from '../../../../store/reducers/registrationSettingsReducer'; 

function SecondaryContract({ countryCodeArr }) {
    const dispatch = useDispatch();
    const promoCode = useSelector(promoCodeSelector);
    const primContract = useSelector(primaryContractSelector);
    const secondContract = useSelector(secondContractSelector);
    const scroll = useSelector(scrollMobileSelector);
    const registrationData = useSelector(registrationSettingsSelector);
    const [scrollClass, setScrollClass] = useState(scroll);
    let history = useHistory();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const summary = params?.get("summary");
    const [emailValidation, setEmailValidation] = useState(emailValidationRegex);
    const [fromSummary, setfromSummary] = useState(false);
    const [fromSummaryConfirmed, setFromSummaryConfirmed] = useState(false);
    const [countryCode, setCountryCode] = useState(secondContract.countryCode);
    const [methodValue, setMethodValue] = useState(false);
    const [openTooltip, setOpenTooltip] = useState(false);
    const [tooltipClass, setTooltipClass] = useState("more_info-closed small");
    const [openEmail, setOpenEmail] = useState(false);
    const splittData = registrationData.secondary_contract_description.split("<br />");
    const [tooltipClassEmail, setTooltipClassEmail] = useState("more_info-inline");
    const [selectClass, setSelectClass] = useState("react-select");
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const span = useRef();
    const span2 = useRef();
    const filteredArray = countryCodeArr.filter((code) => {
        return code.value === secondContract.countryCode;
    });

    useEffect(() => {
        if (summary) {
            setfromSummary(summary);
        }
    }, [summary]);

    useEffect(() => {
        if (countryCode !== undefined) {
            setMethodValue(true);
        }
        if(promoCode.isHuri === true) {
            setEmailValidation(emailValidationRegexAllowPersonal);
        }       
        window.scrollTo(0, 0);
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []); // eslint-disable-line
    useEffect(() => {
        setTimeout(function(){ setScrollClass("progression_container small") ; }, 10);
        document.addEventListener("mousedown", handleClickTooltip);
        return () => {
            document.removeEventListener("mousedown", handleClickTooltip);
        };
    }, []); // eslint-disable-line

    const handleClick = (e) => {
        if (span.current.contains(e.target)) {
            setOpenTooltip(true);
            setTooltipClass("more_info-active small");
            return;
        }
        setOpenTooltip(false);
        setTooltipClass("more_info-closed small");
    };
    
    const handleClickTooltip = e => {
        if (span2.current.contains(e.target)) {
            setOpenEmail(true)
            setTooltipClassEmail("more_info-inline active")
            return;
        }
        setOpenEmail(false)
        setTooltipClassEmail("more_info-inline closed")
    };

    function onSubmit(data, event) {
        data = {
            firstName: data.firstName,
            lastName: data.lastName,
            countryCode: countryCode,
            mobileNum: data.mobileNum,
            email: data.email,
        };

        if (methodValue) {
            if (summary === "true" && fromSummaryConfirmed === true) {
                dispatch(secondContractAdded(data));
                dispatch(pathAdded(history.location.pathname));
                dispatch(classAddedMobile("progression_container small startBottom"));
                history.push("/form/summary");
            } else {
                dispatch(pathAdded(history.location.pathname));
                dispatch(secondContractAdded(data));
                dispatch(classAddedMobile("progression_container small startBottom"));
                if(promoCode.isHuri === true) {
                    history.push("/form/nomination");
                } else {
                    history.push("/form/summary")
                }      
            }
        }
    }

    function setMethod(e) {
        setMethodValue(true);
        setCountryCode(e.value);
    }

    function handleSelectClass() {
        if (methodValue === false) {
            setSelectClass("select-error");
        }
    }

    function goToSummaryCheck() {
        if (methodValue === false) {
            setFromSummaryConfirmed(false);
        } else {
            setFromSummaryConfirmed(true);
        }
    };

    function setClass() {
        dispatch(classAddedMobile("progression_container small startTop"));
    };

    function setIsSkipped() {
        dispatch(pathAdded(history.location.pathname));
        dispatch(classAddedMobile("progression_container small startBottom"));
        dispatch(isSkippedAdded(true));
        history.push("/form/nomination");
    }

    return (
        <div className={scrollClass}>
            <h2>
                Secondary contract administrator
                <span className={tooltipClass} ref={span} onClick={handleClick}>
                    {openTooltip && (
                        <Tooltip
                            title=""
                            text={promoCode.isHuri === true ? "Secondary contract administrator is recommended, but optional. This person will be our secondary point of contact if primary contact is not available." : splittData[0] + splittData[1] }
                        />
                    )}
                </span>
            </h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                    <label htmlFor="firstName">First name</label>
                    <input
                        type="text"
                        defaultValue={secondContract.firstName}
                        className={errors.firstName ? "errorInput" : ""}
                        name="firstName"
                        placeholder="Enter your first name"
                        {...register("firstName", {
                            required: "First name is required",
                            minLength: {
                                value: 2,
                                message: "Must be longer than 2 letters",
                            },
                            pattern: {
                                value: nameValidationRegex,
                                message: "Cannot contain numbers or special characters",
                            },
                        })}
                    />
                    {errors.firstName && (
                        <ErrorMessage>{errors.firstName.message}</ErrorMessage>
                    )}
                </div>

                <div className="form-group">
                    <label htmlFor="lastName">Last name</label>
                    <input
                        type="text"
                        defaultValue={secondContract.lastName}
                        className={errors.lastName ? "errorInput" : ""}
                        name="lastName"
                        placeholder="Enter your last name"
                        {...register("lastName", {
                            required: "Last name is required",
                            minLength: {
                                value: 2,
                                message: "Must be longer than 2 letters",
                            },
                            pattern: {
                                value: nameValidationRegex,
                                message: "Cannot contain numbers or special characters",
                            },
                        })}
                    />
                    {errors.lastName && (
                        <ErrorMessage>{errors.lastName.message}</ErrorMessage>
                    )}
                </div>

                <div className="form-group_container">
                    <div className="form-group form-countryCode">
                        <label htmlFor="countryCode">Country code</label>
                        <Select
                            className={methodValue === false && selectClass}
                            name="countryCode"
                            defaultValue={
                                secondContract.countryCode !== undefined
                                    ? {
                                          label: filteredArray[0].label,
                                          value: secondContract.countryCode,
                                      }
                                    : { label: " - ", value: "" }
                            }
                            options={countryCodeArr}
                            searchable={false}
                            onChange={setMethod}
                            classNamePrefix="react-select"
                        />
                        {selectClass === "select-error" &&
                            methodValue === false && (
                                <ErrorMessage>
                                    Please select a country code
                                </ErrorMessage>
                            )}
                    </div>

                    <div className="form-group form-mobile">
                        <label htmlFor="mobileNum">Mobile number</label>
                        <input
                            type="text"
                            defaultValue={secondContract.mobileNum}
                            className={errors.mobileNum ? "errorInput" : ""}
                            name="mobileNum"
                            placeholder="Enter your mobile number"
                            {...register("mobileNum", {
                                required: "Mobile number is required",
                                pattern: {
                                    value: /^([0-9]){4,12}$/,
                                    message:
                                        "invalid phone number. Example (12345678)",
                                },
                            })}
                        />
                        {errors.mobileNum && (
                            <ErrorMessage>
                                {errors.mobileNum.message}
                            </ErrorMessage>
                        )}
                    </div>
                </div>

                <div className="form-group">
                    <label className="email" htmlFor="email">E-mail
                        <span 
                            className={tooltipClassEmail} 
                            ref={span2}
                            onClick={handleClickTooltip}>                  
                                {openEmail && (
                                    <Tooltip title="" text={registrationData.secondary_contract_email_information}/>
                                )}
                        </span>
                    </label>
                    <input
                        type="text"
                        defaultValue={secondContract.email}
                        className={errors.email ? "errorInput" : ""}
                        name="email"
                        placeholder="Enter your personal company email"
                        {...register("email", {
                            required: "Email is required",
                            pattern: {
                                value: emailValidation,
                                message: "Invalid email address. Example: (john@yourcompany.no)",
                            },
                                validate: (value) => value !== primContract.email                                                    
                            }
                        )} 
                    />
                    {errors.email && errors.email.type === "validate" && <ErrorMessage>E-mail cannot be the same as the Primary contract administrator e-mail</ErrorMessage>}
                    {errors.email && (
                        <ErrorMessage>{errors.email.message}</ErrorMessage>
                    )}
                </div>

                <div className="button_container">
                    {!fromSummary ? (
                        <Link to={`/form/primary`} onClick={setClass} className="previous">
                            <span>
                                <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                                </svg>
                            </span> Previous
                        </Link>
                    ) : (
                        <button className="summaryNavButton" type="submit" onClick={() => { handleSelectClass(); goToSummaryCheck(); }}>
                            Back to summary
                        </button>
                    )}

                    <button onClick={() => { handleSelectClass(); window.plausible('Registration Secondary Contract'); }} className="nextSubmit next" type="submit">
                        <span>Next</span>
                        <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                        </svg>
                    </button>
                    {promoCode.isHuri === true &&
                        <button onClick={() => { setIsSkipped(); window.plausible('Registration Secondary Contract Skip'); }} className="nextSubmit next skip skipMobile" type="submit">
                            <span>Skip this step</span>
                            <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                            </svg>
                        </button>
                    }
                </div>
            </form>
        </div>
    );
}

export default SecondaryContract;
